export interface DeepLinkParsed {
  route: string
  queryParams: Record<string, string>
  hashParams: Record<string, string>
}

/**
 * Parsea una URL de deeplink en sus componentes.
 *
 * Soporta:
 *  - Universal Links: https://auraview.auravant.com/histogram#field=uuid&farm=uuid
 *  - Custom Scheme:   auravant://histogram#field=uuid
 *  - Solo path:        /histogram#field=uuid
 *
 * @example
 * splitRoute('https://auraview.auravant.com/marketplace?install=abc#field=uuid')
 * // { route: 'marketplace', queryParams: { install: 'abc' }, hashParams: { field: 'uuid' } }
 */
export function splitRoute (url: string): DeepLinkParsed {
  let path: string

  try {
    // Universal links (https://) o custom scheme con ://
    if (url.includes('://')) {
      const parsed = new URL(url)
      // pathname + search + hash
      path = parsed.pathname.replace(/^\//, '') + parsed.search + parsed.hash
    } else {
      path = url.replace(/^\//, '')
    }
  } catch {
    path = url.replace(/^\//, '')
  }

  // Separar hash
  const [beforeHash, hashString] = path.split('#')

  // Separar query params del path
  const [route, queryString] = beforeHash.split('?')

  const queryParams: Record<string, string> = {}
  if (queryString) {
    new URLSearchParams(queryString).forEach((v, k) => { queryParams[k] = v })
  }

  const hashParams: Record<string, string> = {}
  if (hashString) {
    // El hash puede contener query params después de ?
    // ej: #field=123&date=2026-03-11?utm_source=... → separar en "?" primero
    const [hashFragment] = hashString.split('?')
    new URLSearchParams(hashFragment).forEach((v, k) => { hashParams[k] = v })
  }

  return { route: route || '', queryParams, hashParams }
}
